<template>
  <div class="tw-bg-white tw-p-20 tw-rounded-lg tw-flex tw-flex-col tw-justify-center tw-items-center tw-gap-y-12">
    <svg-vue
      icon="illustrations/clock"
      class="tw-w-44"
    />

    <div class="tw-gap-6 tw-flex tw-flex-col tw-items-center">
      <span class="tw-font-bold tw-text-2xl tw-text-neutral-900">
        Almost finished!
      </span>

      <span class="tw-text-base tw-text-neutral-700">
        We’re currently running your audit. Please check back shortly.
      </span>
    </div>
  </div>
</template>

